import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function DriverCertificationReportGet(reportID: number, company: number, donorStatus: number): Observable<string> {
  const requestBody: string = JSON.stringify({
    ClientDetails: {},
    ReportID: reportID,
    Company: [company],
    DonorStatus: donorStatus,
    BreakByCompanies: true
  })

  return ObservableFromFetch<string>("WorkforceReport/DriverReport", requestBody)
}
